var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{attrs:{"size":"sm","text":_vm.currentProject.htmlStatus.name,"variant":_vm.statusBtnVariant}},_vm._l((_vm.statuses),function(status){return _c('b-dropdown-item',{key:status.value,attrs:{"disabled":status.value === _vm.currentProject.status},on:{"click":function($event){return _vm.changeStatus(status.value)}}},[_vm._v(_vm._s(status.name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./assets/js/components/ProjectStatusSwitcher.vue?vue&type=template&id=683add4e&
// module id = 414
// module chunks = 0